import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/merchanerp-logo.png';

const css = `
.lp{--bg:#ffffff;--surface:#f5f7fb;--surface-2:#eceff7;--line:#dce2ee;--ink:#101828;--muted:#5a6573;--accent:#2563eb;--accent-ink:#1d4ed8;
  font-family:'IBM Plex Sans',system-ui,-apple-system,sans-serif;color:var(--ink);background:var(--bg);line-height:1.55;min-height:100vh}
.lp *{box-sizing:border-box}
.lp a{color:inherit;text-decoration:none}
.lp .wrap{max-width:1120px;margin:0 auto;padding:0 20px}
.lp h1,.lp h2,.lp h3{margin:0;letter-spacing:-.02em;line-height:1.08;font-weight:800}
.lp p{margin:0}
.lp .nav{position:sticky;top:0;z-index:20;background:rgba(255,255,255,.9);backdrop-filter:blur(10px);border-bottom:1px solid var(--line)}
.lp .nav .wrap{display:flex;align-items:center;gap:18px;min-height:62px}
.lp .nav img{height:26px;display:block}
.lp .nav nav{margin-left:auto;display:flex;align-items:center;gap:20px}
.lp .lk{color:var(--muted);font-weight:500;font-size:14.5px}
.lp .lk:hover{color:var(--ink)}
.lp .btn{display:inline-flex;align-items:center;gap:7px;font-weight:600;font-size:14.5px;padding:10px 17px;border-radius:10px;border:1px solid transparent;cursor:pointer;transition:background .15s}
.lp .btn-primary{background:var(--accent);color:#fff}
.lp .btn-primary:hover{background:var(--accent-ink)}
.lp .btn-ghost{border-color:var(--line);color:var(--ink);background:transparent}
.lp .btn-ghost:hover{background:var(--surface)}
.lp .hero .wrap{display:grid;grid-template-columns:1.05fr .95fr;gap:52px;align-items:center;padding:68px 20px 56px}
.lp .eyebrow{display:inline-flex;align-items:center;gap:8px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--accent);background:var(--surface);border:1px solid var(--line);padding:6px 11px;border-radius:999px;font-weight:600}
.lp .dot{width:7px;height:7px;border-radius:50%;background:var(--accent)}
.lp h1{font-size:clamp(34px,5.4vw,54px);margin:18px 0 0}
.lp .lead{color:var(--muted);font-size:clamp(16px,2vw,18.5px);max-width:30ch;margin-top:18px}
.lp .cta-row{display:flex;flex-wrap:wrap;gap:12px;margin-top:26px}
.lp .cta-row .btn{padding:13px 22px;font-size:15.5px}
.lp .trust{margin-top:22px;color:var(--muted);font-size:13.5px;display:flex;gap:10px;flex-wrap:wrap}
.lp .trust b{color:var(--ink);font-weight:600}
.lp .panel{background:var(--surface);border:1px solid var(--line);border-radius:18px;padding:18px;box-shadow:0 24px 50px -32px rgba(16,24,40,.45)}
.lp .panel-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}
.lp .panel-top .t{font-weight:700;font-size:15px}
.lp .chip{font-size:11px;color:var(--accent);background:var(--surface-2);border:1px solid var(--line);padding:4px 9px;border-radius:999px;font-weight:600}
.lp .tiles{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.lp .tile{background:#fff;border:1px solid var(--line);border-radius:12px;padding:13px 14px}
.lp .tile .k{font-size:12px;color:var(--muted)}
.lp .tile .v{font-weight:800;font-size:22px;margin-top:4px}
.lp .tile .v small{font-size:12px;color:var(--muted);font-weight:500}
.lp .pos{color:var(--accent)}
.lp .bars{display:flex;align-items:flex-end;gap:7px;height:52px;margin-top:12px}
.lp .bars i{flex:1;background:linear-gradient(180deg,var(--accent),var(--accent-ink));border-radius:4px 4px 0 0;opacity:.92}
.lp .ledger{margin-top:12px;border:1px solid var(--line);border-radius:12px;overflow:hidden}
.lp .ledger .row{display:grid;grid-template-columns:1fr auto auto;gap:10px;padding:9px 13px;font-size:12.5px;border-top:1px solid var(--line)}
.lp .ledger .row:first-child{border-top:0;color:var(--muted);font-size:11px;letter-spacing:.04em;text-transform:uppercase}
.lp .ledger .row b{font-weight:600}
.lp .ok{color:var(--accent)}
.lp section{padding:60px 0}
.lp .kicker{font-size:12px;letter-spacing:.1em;text-transform:uppercase;color:var(--accent);font-weight:700}
.lp .sec-head h2{font-size:clamp(26px,3.6vw,38px);margin-top:12px}
.lp .sec-head p{color:var(--muted);margin-top:12px;font-size:16.5px;max-width:52ch}
.lp .grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-top:34px}
.lp .card{background:var(--surface);border:1px solid var(--line);border-radius:14px;padding:22px}
.lp .card .ic{width:40px;height:40px;border-radius:10px;background:var(--surface-2);border:1px solid var(--line);display:grid;place-items:center;color:var(--accent);margin-bottom:14px}
.lp .card .ic svg{width:20px;height:20px}
.lp .card h3{font-size:18px}
.lp .card p{color:var(--muted);font-size:14.5px;margin-top:8px}
.lp .band{background:var(--surface);border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.lp .band .wrap{padding:52px 20px;display:grid;grid-template-columns:1.1fr 1fr;gap:40px;align-items:center}
.lp .band h2{font-size:clamp(24px,3.2vw,32px)}
.lp .band p{color:var(--muted);margin-top:14px;font-size:16px;max-width:46ch}
.lp .facts{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.lp .fact{background:#fff;border:1px solid var(--line);border-radius:12px;padding:16px}
.lp .fact .n{font-weight:800;font-size:26px;color:var(--accent)}
.lp .fact .l{color:var(--muted);font-size:13.5px;margin-top:3px}
.lp .close{background:linear-gradient(155deg,#2563eb,#152a63);color:#fff;border-radius:22px;text-align:center;padding:56px 28px;margin:12px 0}
.lp .close h2{font-size:clamp(26px,4vw,40px)}
.lp .close p{color:#d6e2ff;margin:14px auto 0;max-width:42ch;font-size:16.5px}
.lp .close .cta-row{justify-content:center}
.lp .close .btn-primary{background:#fff;color:#1d4ed8}
.lp .close .btn-ghost{border-color:rgba(255,255,255,.4);color:#fff}
.lp footer{border-top:1px solid var(--line);padding:26px 0;color:var(--muted);font-size:13px}
.lp footer .wrap{display:flex;align-items:center;gap:14px;flex-wrap:wrap;justify-content:space-between}
.lp footer img{height:20px}
@media (max-width:860px){
  .lp .hero .wrap{grid-template-columns:1fr;gap:34px;padding:44px 20px 36px}
  .lp .band .wrap{grid-template-columns:1fr;gap:26px}
  .lp .grid{grid-template-columns:1fr 1fr}
}
@media (max-width:560px){ .lp .grid{grid-template-columns:1fr} .lp .hide-sm{display:none} }
`;

const Landing: React.FC = () => (
  <div className="lp">
    <style>{css}</style>

    <header className="nav">
      <div className="wrap">
        <Link to="/"><img src={logo} alt="MerchanERP" /></Link>
        <nav>
          <a className="lk hide-sm" href="#features">Features</a>
          <a className="lk hide-sm" href="#why">Why MerchanERP</a>
          <Link className="lk" to="/login">Log in</Link>
          <Link className="btn btn-primary" to="/register">Get started</Link>
        </nav>
      </div>
    </header>

    <section className="hero">
      <div className="wrap">
        <div>
          <span className="eyebrow"><span className="dot" />Trading ERP · built for the region</span>
          <h1>Run your whole shop on one honest set of books.</h1>
          <p className="lead">Sales, stock, purchases and real double-entry accounting — in one system your team actually uses, across every branch.</p>
          <div className="cta-row">
            <Link className="btn btn-primary" to="/register">Register your company →</Link>
            <Link className="btn btn-ghost" to="/login">Log in</Link>
          </div>
          <div className="trust">
            <span>New companies are reviewed before activation.</span>
            <span>·</span>
            <span>Works in <b>USD</b> and <b>SOS</b>.</span>
          </div>
        </div>
        <div className="panel" aria-hidden="true">
          <div className="panel-top"><span className="t">This month · Garowe</span><span className="chip">LIVE BOOKS</span></div>
          <div className="tiles">
            <div className="tile"><div className="k">Sales</div><div className="v">$42,180</div></div>
            <div className="tile"><div className="k">Gross profit</div><div className="v pos">$9,640 <small>22.9%</small></div></div>
          </div>
          <div className="bars"><i style={{ height: '38%' }} /><i style={{ height: '54%' }} /><i style={{ height: '47%' }} /><i style={{ height: '66%' }} /><i style={{ height: '72%' }} /><i style={{ height: '61%' }} /><i style={{ height: '88%' }} /></div>
          <div className="ledger">
            <div className="row"><span>Entry</span><span>Debit</span><span>Credit</span></div>
            <div className="row"><b>Cash Sale CS-00388</b><b>21.02</b><span>—</span></div>
            <div className="row"><b>GRN-00213 — Bill</b><b>36.00</b><span>—</span></div>
            <div className="row"><b>Supplier payment PV-00179</b><span>—</span><b>31.60</b></div>
            <div className="row"><span className="ok">Balanced ✓</span><span /><span /></div>
          </div>
        </div>
      </div>
    </section>

    <section id="features">
      <div className="wrap">
        <div className="sec-head">
          <span className="kicker">Everything in one place</span>
          <h2>More than bookkeeping — it runs the business.</h2>
          <p>Each part writes straight to your ledger, so the numbers are always ready — nothing to re-enter, nothing to reconcile by hand.</p>
        </div>
        <div className="grid">
          {[
            ['Sales & POS', 'Cash and invoice sales, customer balances, receipts and returns — fast at the counter, exact in the books.'],
            ['Inventory & transfers', 'Live stock by location, average costing that re-costs itself, and branch-to-branch transfers with full tracking.'],
            ['Purchases & suppliers', 'Goods receipts, bills, supplier payments and one-step cash purchases — payables that always tie out.'],
            ['Real accounting', 'True double-entry with a locked chart of accounts and clean journals. Debits meet credits on every transaction.'],
            ['Reports you know', 'Balance Sheet, P&L, AR/AP aging, sales and inventory — laid out the QuickBooks way your accountant expects.'],
            ['Branches, roles & approvals', 'Many branches, per-user permissions, and approvals on the entries that matter before they hit the ledger.'],
          ].map(([t, d]) => (
            <div className="card" key={t}>
              <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M8 4v16" /></svg></div>
              <h3>{t}</h3>
              <p>{d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section id="why" className="band">
      <div className="wrap">
        <div>
          <span className="kicker">Made for how you trade</span>
          <h2>Familiar to anyone coming from QuickBooks — priced for a growing business.</h2>
          <p>Multi-currency, multi-branch, and quick to learn. Bring your records in and keep your books in one place the whole team can reach.</p>
        </div>
        <div className="facts">
          <div className="fact"><div className="n">2</div><div className="l">currencies — USD &amp; SOS, side by side</div></div>
          <div className="fact"><div className="n">1</div><div className="l">ledger behind every screen</div></div>
          <div className="fact"><div className="n">∞</div><div className="l">branches and users per company</div></div>
          <div className="fact"><div className="n">0</div><div className="l">manual reconciliation at month-end</div></div>
        </div>
      </div>
    </section>

    <section>
      <div className="wrap">
        <div className="close">
          <h2>Start running your business on MerchanERP.</h2>
          <p>Register your company in a few minutes. We'll review it and switch you on.</p>
          <div className="cta-row">
            <Link className="btn btn-primary" to="/register">Register your company →</Link>
            <Link className="btn btn-ghost" to="/login">I already have an account</Link>
          </div>
        </div>
      </div>
    </section>

    <footer>
      <div className="wrap">
        <img src={logo} alt="MerchanERP" />
        <span>© {new Date().getFullYear()} MerchanERP · Clean books for trading businesses.</span>
      </div>
    </footer>
  </div>
);

export default Landing;
